import { useState } from 'react'
import { getEbscoSearch } from '../services/ebsco.service';
import { useSourceSearch } from 'features/SourceSearch';
import { getFilterDateValueKeys } from 'utils/date-filter.util';
import { ebscoLabel } from 'features/SourceSearch/data/search-fields.data';

const useEbscoSearch = (setEbscoSearch, query, setLoadingStates) => {
    const { currentTimeframe, startDate, endDate } = useSourceSearch();

    const filteredDateValue = getFilterDateValueKeys(
      currentTimeframe,
      startDate,
      endDate
    );

    const getEbscoSearchData = async () => {
        try {
          const data = await getEbscoSearch(query, filteredDateValue, 1);
          setEbscoSearch(data);
          setLoadingStates((prev) => ({
            ...prev,
            [ebscoLabel]: false,
          }));
        } catch (e) {
          console.error(e);
        }
    };

  return {
    getEbscoSearchData,
  };
}

export default useEbscoSearch
